import React from "react";
import GoogleChart from "../../../../components/googleChart/googleChart";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import { useDispatch, useSelector } from "react-redux";

const TableOrStackedBarChart = () => {
  const dispatch = useDispatch();
  const table_view = useSelector((state) => state.onDemandRevenue.selectedFilters.table_view);
  const {
    listeners,
    options,
    data_table: { rows, cols }
  } = useSelector((state) => state.onDemandRevenue.chartData);

  const { currencySymbol } = useSelector((state) => state.onDemandRevenue.currentUser);

  const handleUpdateChart = (data) => {
    dispatch(actionCreators.updateTableView(data));
  };

  return (
    <GoogleChart
      chartName="sales_revenue_service_sales_chart"
      width="1350px"
      height={400}
      isTableView={table_view}
      rows={rows}
      columns={cols}
      listeners={listeners}
      options={options}
      enableEventListeners
      switchView={handleUpdateChart}
      currencySymbol={currencySymbol}
    />
  );
};

export default TableOrStackedBarChart;
